import { Component, ViewChild} from '@angular/core';
import {ApiService, Helper} from "../api.service";
import {
  MatCell, MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef,
  MatRow, MatRowDef,
  MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {Router} from "@angular/router";
import {MatButton, MatIconButton} from "@angular/material/button";
import { saveAs } from 'file-saver';
import { unparse } from 'papaparse';

@Component({
  selector: 'app-users',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderRow,
    MatRow,
    MatIcon,
    MatTooltip,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatSortHeader,
    MatSort,
    MatProgressSpinner,
    MatIconButton,
    MatButton
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css'
})
export class UsersComponent {
  public displayedColumns: string[] = ['id', 'email', 'data', 'action'];
  public dataSource: any;
  public loading: boolean = false;
  private data: any[] = [];

  @ViewChild(MatSort) sort: MatSort | undefined;

  constructor(private api: ApiService, private router: Router) {
    (document.querySelector('body') as HTMLElement).style.backgroundImage = 'unset';
    this.loading = true;
    this.api.getRespondents().then(data => {
      this.data = data;
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.loading = false;
    });
  }

  protected readonly Helper = Helper;

  goToUser(id: string) {
    this.router.navigate(['admin/user', id]);
  }

  exportData() {
    const data = this.data.map(item => ({
      ...item,
      activities: JSON.stringify(item.activities)
    }));
    const csv = unparse(data);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'report.csv');
  }


}
